<template>
  <div class="frm-toggle">
    <input type="checkbox" :name="valueKey" :id="valueKey" v-model="internalValue" @click="$emit('click', $event.target.checked)" />
    <label :for="valueKey">
      {{ label }}
    </label>
  </div>
</template>

<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'

  export default {
    mixins: [ ValueInputBindings ],
    props: {
      label: String,
      value: [Number, String, Date, Boolean],
      valueKey: String,
      disabled: Boolean
    }
  }
</script>
